import getDateDifference from '../utils/getDateDifference';
import getDataPoint from '../utils/getDataPoint';
import { compareValues } from '../utils/compareValues';
import { PerformanceCheck } from '../models/config';
import PerformanceCheckOptions from '../models/utils/PerformanceCheckOptions';

export const performanceCheck = (options: PerformanceCheckOptions): boolean => {
    const { config, shareClass, dataStore } = options;
    const { performanceCheck: perfCheck = {} } = config;
    const {
        startDate,
        endDate,
        data,
        operator,
        period,
        value,
    } = perfCheck as PerformanceCheck;

    if (startDate && endDate) {
        // Get startDate value, convert to Date
        const startDateValue = getDataPoint({
            dataStore,
            shareClass,
            dataConfig: startDate,
            hasPerformance: true,
        });
        const startDateDate = new Date(startDateValue);

        // Get endDate value, convert to Date
        const endDateValue = getDataPoint({
            dataStore,
            shareClass,
            dataConfig: endDate,
            hasPerformance: true,
        });
        const endDateDate = new Date(endDateValue);

        const dateDifference = getDateDifference(
            endDateDate,
            startDateDate,
            period
        );

        return compareValues(dateDifference, operator, value);
    }

    if (data) {
        const dataValue = getDataPoint({
            dataStore,
            shareClass,
            dataConfig: data,
            hasPerformance: true,
        });
        return compareValues(dataValue, operator, value);
    }

    return true;
};

export default performanceCheck;



// WEBPACK FOOTER //
// ./src/utils/performanceCheck.ts